import React from 'react';
import '../styles/process.page.scss';
import { Container, Col } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';

export default function TermsAndConditions({ l }) {
    return (
        <Container>
            <PageTitle title={l.pageTitle} />
            <div className="mt-n3">
                {l.sections.map((section, i) => renderFaq(section, i))}
            </div>
        </Container>
    )
}

function renderFaq(section, i) {
    return (
        <Col xs={12} lg={10} className="mt-1 mt-md-3" key={`section-${i}`}>
            <div>
                <p className="mb-1 h4 font-weight-bold" dangerouslySetInnerHTML={{__html: section.header}}></p>
            </div>
            <div>
                <p className="" dangerouslySetInnerHTML={{__html: section.body}}></p>
            </div>
        </Col>
    )
}